import script from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"

import "./FullscreenSpin.vue?vue&type=style&index=0&id=16ead44e&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ead44e"]])

export default __exports__